import _api from '../_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    update (_, payload,) {
      return _api.patch(payload,);
    },
    bulkUpdate (_, payload,) {
      return _api.bulkUpdate(payload,);
    },
  },
};
